import React, { useContext } from 'react'
import { useHistory, useParams, useLocation } from 'react-router-dom'
import './Settings.css'
import { useTranslation } from 'react-i18next'
import { Translation } from '../../../types'
import { AppContext } from '../../../../global'

type Params = {
  accountId: string
}

export function getSettings(accountId: string, t: Translation, isPapertrailEmployee?: boolean) {
  let settings = [
    {
      key: 'details',
      url: `/account/${accountId}/settings`,
      text: t('settings_details:settings_tab')
    }
  ]

  if (isPapertrailEmployee) {
    settings.push({
      key: 'blueprint',
      url: `/account/${accountId}/settings/blueprint`,
      text: t('settings_blueprint:settings_tab')
    })
  }

  settings = settings.concat([
    {
      key: 'address',
      url: `/account/${accountId}/settings/address`,
      text: t('settings_address:settings_tab')
    },
    {
      key: 'contacts',
      url: `/account/${accountId}/settings/contacts`,
      text: t('settings_contacts:settings_tab')
    },
    {
      key: 'certificates',
      url: `/account/${accountId}/settings/certificates`,
      text: t('settings_certificates:settings_tab')
    },
    {
      key: 'importing',
      url: `/account/${accountId}/settings/importing`,
      text: t('settings_importing:settings_tab')
    },
    {
      key: 'records',
      url: `/account/${accountId}/settings/records`,
      text: t('settings_records:settings_tab')
    },
    {
      key: 'frequencies',
      url: `/account/${accountId}/settings/frequencies`,
      text: t('settings_frequencies:settings_tab')
    },
    {
      key: 'states',
      url: `/account/${accountId}/settings/states`,
      text: t('settings_states:settings_tab')
    },
    {
      key: 'filters',
      url: `/account/${accountId}/settings/filters`,
      text: t('settings_filters:settings_tab')
    },
    {
      key: 'tags',
      url: `/account/${accountId}/settings/tags`,
      text: t('settings_tags:settings_tab')
    },
    {
      key: 'actions',
      url: `/account/${accountId}/settings/actions`,
      text: t('settings_actions:settings_tab')
    }
  ])

  if (isPapertrailEmployee) {
    settings.push({
      key: 'invitations',
      url: `/account/${accountId}/settings/invitations`,
      text: t('settings_invitations:settings_tab')
    })
  }

  settings.push({
    key: 'checklists',
    url: `/account/${accountId}/settings/checklists`,
    text: t('settings_checklists:settings_tab')
  })

  return settings
}

function SettingsMenu() {
  const history = useHistory()
  const { accountId } = useParams() as Params
  const location = useLocation()
  const { t } = useTranslation(['settings_details', 'settings_certificates'])
  const { state } = useContext(AppContext)
  const isPapertrailEmployee = state.auth.isPapertrailEmployee
  const settings = getSettings(accountId, t, isPapertrailEmployee)

  function onNavigateClick(url: string) {
    history.push(url)
  }

  function getStyle(url: string) {
    return location.pathname === url
      ? 'selected-menu-item-text'
      : 'unselected-menu-item-text'
  }

  function getIndicator(url: string) {
    return location.pathname === url
      ? 'selected-menu-indicator'
      : 'deselected-menu-indicator'
  }

  return (
    <div id="settings-menu">
      {settings.map(setting => (
        <div className="settings-menu-item"
          key={setting.key}
          data-cy={setting.key}
          onClick={() => onNavigateClick(setting.url)}>
          <div className={getIndicator(setting.url)} />
          <div className="settings-menu-item-inner">
            <span className={getStyle(setting.url)}>
              {setting.text}
            </span>
          </div>
        </div>
      ))}
    </div>
  )
}

export default SettingsMenu
